import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { getQuery } from 'app/views/tabellaPocr/ServiceController';
import useFseHide from 'app/views/hooks/useFseHide';

const RegistrationReminderAlert = () => {
    const [visible, setVisible] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const effectRan = useRef(false);
    const isFse = useFseHide();

    useEffect(() => {
        if (effectRan.current) return;
        if (!isFse) return;
        effectRan.current = true;
        dispatch(getQuery("ProfiloFse/GetProfilo"))
            .then((res) => {
                if (res.isSuccess) {
                    setVisible(res.data.isLater);
                }
            })
            .catch((err) => console.log(err));

    }, [dispatch]);

    const handleNavigation = () => {
        setVisible(false);
        navigate('/info-account', { state: { edit: true } });
    };

    if (!visible) return null;

    return (
        <div className="alert alert-info d-flex justify-content-between align-items-center">
            <span className="flex-1">
                📌 Ricordati di completare la registrazione per goderti al massimo l’esperienza personalizzata di Referto FSE!
            </span>

            <div className="flex gap-2">
                <button
                    onClick={handleNavigation}
                    className="btn btn-primary"
                >
                    Vai a informazioni account
                </button>
            </div>
            <button
                onClick={() => setVisible(false)}
                className="btn-close alert-close-button"
                aria-label="Chiudi"
            >
            </button>
        </div>
    );
};

export default RegistrationReminderAlert;
